import { render } from "./LocationsEdit.vue?vue&type=template&id=7720d61b"
import script from "./LocationsEdit.vue?vue&type=script&lang=js"
export * from "./LocationsEdit.vue?vue&type=script&lang=js"
script.render = render

export default script